// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const teamBoardSlice = createSlice({
  name: "teamBoard",
  initialState: {
    cards: [],
    selectedCard: null,
    loading: false,
  },
  reducers: {
    setCards: (state, action) => {
      state.cards = action.payload;
    },
    appendCards: (state, action) => {
      state.cards = [...state.cards, ...action.payload];
    },
    clearCards: (state) => {
      state.cards = [];
    },
    setSelectedCard: (state, action) => {
      state.selectedCard = action.payload;
    },
    clearSelectedCard: (state) => {
      state.selectedCard = null;
    },
    updateCard: (state, action) => {
      const index = state.cards.findIndex(
        (card) => card.id === action.payload.id
      );
      if (index !== -1) {
        state.cards[index] = { ...state.cards[index], ...action.payload };
      } else {
        // If card is not in the list, add it
        state.cards.push(action.payload);
      }
      // Also update selectedCard if it's the same card
      if (state.selectedCard?.id === action.payload.id) {
        state.selectedCard = action.payload;
      }
    },
    removeCard: (state, action) => {
      state.cards = state.cards.filter(
        (card) => card.id !== action.payload
      );
      // Clear selected card if it was removed
      if (state.selectedCard?.id === action.payload) {
        state.selectedCard = null;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});
export const {
  setCards,
  appendCards,
  clearCards,
  setSelectedCard,
  clearSelectedCard,
  updateCard,
  removeCard,
  setLoading,
} = teamBoardSlice.actions;
export default teamBoardSlice.reducer;
